import { MaintenanceRecipe, RepoBulkAction } from '@developerz/domain';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { RepoEnablementPicker } from '../lib/repo-enablement-picker';
import { Field } from './Field';
import { Select } from './Select';
import { Button } from './ui/Button';

// How, and the two acts. Presenter. A press asks the server for a count; the confirm acts.

const recipeOptions = (): { value: MaintenanceRecipe; label: string; desc: string }[] => [
  {
    value: MaintenanceRecipe.MaintainAutoMerge,
    label: t('repo_enablement.recipe_maintain_auto_merge'),
    desc: t('repo_enablement.recipe_maintain_auto_merge_desc'),
  },
  {
    value: MaintenanceRecipe.ReviewOnly,
    label: t('repo_enablement.recipe_review_only'),
    desc: t('repo_enablement.recipe_review_only_desc'),
  },
  {
    value: MaintenanceRecipe.IssuesOnly,
    label: t('repo_enablement.recipe_issues_only'),
    desc: t('repo_enablement.recipe_issues_only_desc'),
  },
];

export function RepoEnablementAct(props: { readonly picker: RepoEnablementPicker }): JSX.Element {
  const shut = (): boolean =>
    props.picker.selectedCount() === 0 ||
    props.picker.tooMany() ||
    props.picker.ask.pending() ||
    props.picker.act.pending();
  return (
    <div class="repo-enablement__act">
      <Field
        id="repo-enablement-recipe"
        label={t('repo_enablement.recipe_label')}
        desc={recipeOptions().find((option) => option.value === props.picker.recipe())?.desc}
      >
        {(a11y) => (
          <Select
            a11y={a11y}
            label={t('repo_enablement.recipe_label')}
            value={props.picker.recipe()}
            options={recipeOptions().map(({ value, label }) => ({ value, label }))}
            onChange={(value) => props.picker.setRecipe(value as MaintenanceRecipe)}
            block
          />
        )}
      </Field>
      <div class="repo-enablement__buttons">
        <Button
          variant="brand"
          disabled={shut()}
          onClick={() => void props.picker.ask.run(RepoBulkAction.Enable)}
        >
          {t('repo_enablement.enable')}
        </Button>
        <Button
          variant="outline"
          disabled={shut()}
          onClick={() => void props.picker.ask.run(RepoBulkAction.Disable)}
        >
          {t('repo_enablement.disable')}
        </Button>
      </div>
    </div>
  );
}
